"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.light = exports.dark = void 0;
var _styledComponents = require("styled-components");
var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var light = (0, _styledComponents.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: linear-gradient(90deg,rgb(236 236 236) 8%,rgb(245 245 245) 18%,rgb(236 236 236) 33%);\n"], ["\n    background: linear-gradient(90deg,rgb(236 236 236) 8%,rgb(245 245 245) 18%,rgb(236 236 236) 33%);\n"])));
exports.light = light;
var dark = (0, _styledComponents.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    background: linear-gradient(90deg,rgb(200 200 200) 8%,rgb(255 255 255) 18%,rgb(200 200 200) 33%);\n"], ["\n    background: linear-gradient(90deg,rgb(200 200 200) 8%,rgb(255 255 255) 18%,rgb(200 200 200) 33%);\n"])));
exports.dark = dark;
var templateObject_1, templateObject_2;